<div class="max-h-[90vh] overflow-y-auto p-2 sm:p-0">
  @if (filterConfig(); as filterConfig) {
    <h1 class="text-xl font-semibold">{{'#APPLICATION.FILTER_AND_SORT.FILTER.TITLE' | translate}}</h1>
    <soft-filter-list [filters]="filters() ?? []"
                      [items]="items() ?? []"
                      (filtersChange)="currentFilters.set($event)"
                      [config]="filterConfig"></soft-filter-list>
  }
  @if(filterConfig() && sortConfig()) {
    <div class="px-4 sm:px-0 w-full">
      <hr class="soft-separator" />
    </div>
  }
  @if (sortConfig(); as sortConfig) {
    <h1 class="text-xl font-semibold">{{'#APPLICATION.FILTER_AND_SORT.SORT.TITLE' | translate}}</h1>
    <soft-sort-form [sort]="sort()"
                    [config]="sortConfig"
                    (sortChange)="currentSort.set($event)"></soft-sort-form>
  }
  <ng-container *ngIf="sortConfig">
  </ng-container>
  <div class="w-full mt-4">
    <button class="soft-button accent h-16 w-full rounded"
            (click)="onSubmit()">
      {{'#APPLICATION.FILTER_AND_SORT.SUBMIT' | translate}}
    </button>
  </div>
</div>
